// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"EditProfileForm_card_footer__24STq","card_footer_fixed":"EditProfileForm_card_footer_fixed__1RhrR","card_content":"EditProfileForm_card_content__3gFM6"};